import { isMobile } from '../helpers/isMobile';

export const GAME_SPEED_TYPES = {
  standard: 'standard',
  fast: 'fast',
  turbo: 'turbo',
};

// RU: `sharedTicker` — на ОБЕИХ платформах (engine-gotcha №2). GSAP качается от Ticker.shared
//     (helpers/configuratedStage), и без флага у мобильного приложения был свой тикер со своим
//     rAF: рендер и твины барабанов шли двумя независимыми циклами.
export const stageOptions = isMobile()
  ? { transparent: true, backgroundAlpha: 0, resolution: 2, sharedTicker: true }
  : {
    resolution: 1.5,
    antialias: false,
    autoDensity: true,
    transparent: true,
    sharedTicker: true,
    forceCanvas: false,
    powerPreference: 'high-performance',
  };
